export const DEFAULT_MENU_ORDER = {
  questions: 1,
  answer_sheet: 2,
  bonus_challenge: 3,
  final_questions: 4,
  emergency_message: 5,
  checklists: 6,
  mystery_message: 7,
}

export const MENU_SECTION_KEYS = Object.keys(DEFAULT_MENU_ORDER)

export function getMergedMenuOrder(hunt) {
  const saved = hunt && hunt.menu_order ? hunt.menu_order : {}
  return { ...DEFAULT_MENU_ORDER, ...saved }
}

export function isMenuSectionVisible(sectionKey, huntData, { huntStatus, showQuestions }) {
  const hunt = huntData.hunt || {}

  switch (sectionKey) {
  case `questions`:
    return huntData.questions !== undefined && huntData.questions.length > 0
  case `answer_sheet`:
    if (hunt.enable_answer_sheet === undefined || !hunt.enable_answer_sheet) {
      return false
    }
    if (showQuestions) {
      return true
    }
    return huntStatus !== `pending`
  case `final_questions`:
    return huntData.secondary_questions !== undefined && huntData.secondary_questions.length > 0
  case `bonus_challenge`:
    if (hunt.enable_bonus_challenge === undefined || !hunt.enable_bonus_challenge) {
      return false
    }
    if (showQuestions) {
      return true
    }
    return huntStatus === `started`
  case `checklists`:
    return huntData.checklists !== undefined && huntData.checklists.length > 0
  case `mystery_message`:
    return huntData.mystery_message !== undefined && huntData.mystery_message !== null
  case `emergency_message`:
    return huntData.emergency_message !== undefined && huntData.emergency_message !== null
  default:
    return false
  }
}

export function getOrderedMenuSections(huntData, { huntStatus, showQuestions = false } = {}) {
  const mergedOrder = getMergedMenuOrder(huntData.hunt)

  return MENU_SECTION_KEYS.slice()
    .sort((a, b) => mergedOrder[a] - mergedOrder[b])
    .filter(key => isMenuSectionVisible(key, huntData, { huntStatus, showQuestions }))
}
